import { campaignProgress, parseCampaignDeadline } from './campaign-header.js';

export const siteSettingKeys = Object.freeze([
  'campaign_alert',
  'campaign_text',
  'campaign_progress',
  'campaign_end_date',
  'popup_activated',
  'popup_url'
]);
const locales = new Set([
  'en',
  'de',
  'tr',
  'fr',
  'es',
  'pt',
  'it',
  'ar',
  'hi',
  'ur',
  'ru',
  'ja',
  'zh'
]);
export const siteSettingsCacheMs = 60_000;
export function siteSettingsLanguage(path) {
  const prefix = String(path || '')
    .split('/')[1]
    ?.toLowerCase();
  return locales.has(prefix) ? prefix : 'en';
}
export function settingEnabled(value) {
  return typeof value === 'string'
    ? ['1', 'true', 'yes', 'on'].includes(value.trim().toLowerCase())
    : value === true || value === 1;
}
export function normalizeSiteSettings(response) {
  const data = response?.data ?? response;
  if (
    !data ||
    typeof data !== 'object' ||
    Array.isArray(data) ||
    !siteSettingKeys.some((key) => Object.hasOwn(data, key))
  ) {
    throw new Error('Invalid public site settings response');
  }
  return Object.fromEntries(
    siteSettingKeys.map((key) => [key, data[key] ?? null])
  );
}
export function cachedSiteSettings(entry, locale, now = Date.now()) {
  if (
    entry?.locale !== locale ||
    !entry.settings ||
    !Number.isFinite(entry.fetchedAt)
  )
    return undefined;
  const age = now - entry.fetchedAt;
  return age >= 0 && age < siteSettingsCacheMs ? entry : undefined;
}
function hashString(value) {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(36);
}
export function siteCampaignOffer(data, locale, now = Date.now()) {
  const text =
    typeof data?.campaign_text === 'string' ? data.campaign_text.trim() : '';
  if (!settingEnabled(data?.campaign_alert) || !text) return null;
  const raw = data.campaign_end_date;
  const hasDeadline =
    raw != null && String(raw).trim() !== '' && String(raw).trim() !== '0';
  const deadline = parseCampaignDeadline(raw);
  if (hasDeadline && (!deadline || deadline <= now)) return null;
  const progress = campaignProgress(data.campaign_progress);
  return {
    key: `${locale}:${deadline}:${hashString(text)}`,
    text,
    deadline,
    progress,
    showProgress: progress > 0
  };
}
